module.exports = __webpack_public_path__ + "static/Muhammad-Gangat-3173229c6a4b40675d02c617ad75129f.png";